import React, { useEffect } from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederUtvekslingDto from '../Models/VeilederUtvekslingDto';
import { VeilederUtvekslingAppState } from '../Store';
import { connect } from 'react-redux';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { SatserUtlandModel } from '../Models/SatserUtlandModel';
import * as ValgTypes from '../Store/Valg/Types';
import * as UtregningUtland from '../Utilities/Utregning';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface UtbetalingOwnProps {
    satser: SatserUtlandModel | null;
    valg: ValgTypes.ValgState;
    locale: string;
    valuta: string;
}

type UtbetalingProps = UtbetalingOwnProps & MapStateToProps & {};

const UtbetalingDetaljerComponent = (props: UtbetalingProps): JSX.Element => {
    const { epiContext } = props;

    let skolepengeUtvidetStipend: number = UtregningUtland.regnUtSkolepengeUtvidetStipend(props.valg, props.satser);
    let skolepengeLanUtenUtvidetStipend =
        UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).stipendKroner - skolepengeUtvidetStipend;    

    useEffect(() => {
        updateLiveMessage();
    }, []);
    
    function hentSkolepengeStipend(): JSX.Element | null {
        if (props!.valg!.dSkolepenger!.tillegg) return null;

        if (skolepengeUtvidetStipend > 0) {
            return (
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerSkolepengeStipend')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(skolepengeLanUtenUtvidetStipend, props.locale)}
                        &nbsp;{props.valuta}
                    </div>
                    ;
                </div>
            );
        } else {
            return (
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerSkolepengeStipend')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(
                            UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).stipendKroner,
                            props.locale,
                        )}
                        &nbsp;{props.valuta}
                    </div>
                </div>
            );
        }
    }

    function hentTilleggsstipend(): JSX.Element | null {
        if (props!.valg!.dSkolepenger!.tillegg) return null;

        if (skolepengeUtvidetStipend > 0) {
            return (
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerSkolepengeTilleggsstipend')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(skolepengeUtvidetStipend, props.locale)}
                        &nbsp;{props.valuta}
                    </div>
                </div>
            );
        }
        return null;
    }

    return (
        <div>
            <h4>{contentResolver(epiContext, 'tittelYtelser')}</h4>
            <div role="table" className="c-table">
                <div role="row" className="c-table__header-row">
                    <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                        {contentResolver(epiContext, 'tittelYtelseKolonne')}
                    </div>
                    <div role="columnheader" className="c-table__header-cell c-table__header-cell--lilac">
                        {contentResolver(epiContext, 'tittelBelopKolonne')}
                    </div>
                </div>
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerBasisLan')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(
                            UtregningUtland.regnUtBasisLan(props.valg, props.satser).totaltStipendOgLan,
                            props.locale,
                        )}
                        &nbsp;{props.valuta}
                    </div>
                </div>
                {UtregningUtland.regnUtRekrutteringsstipendUtveksling(props.valg, props.satser) > 0 && (
                    <div role="row" className="c-table__data-row">
                        <div role="cell" className="c-table__data-cell">
                            {contentResolver(epiContext, 'detaljerTilleggsStipendUtveksling')}
                        </div>
                        <div role="cell" className="c-table__data-cell">
                            {UtregningUtland.formatNumber(
                                UtregningUtland.regnUtRekrutteringsstipendUtveksling(props.valg, props.satser),
                                props.locale,
                            )}
                            &nbsp;{props.valuta}
                        </div>
                    </div>
                )}
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerSkolepengeLan')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(
                            UtregningUtland.regnUtSkolepengerStotte(props.valg, props.satser).lanKroner,
                            props.locale,
                        )}
                        &nbsp;{props.valuta}
                    </div>
                </div>
                {hentSkolepengeStipend()}
                {hentTilleggsstipend()}
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerReiselan')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(
                            UtregningUtland.regnUtReiseStotte(props.valg, props.satser).lanKroner,
                            props.locale,
                        )}
                        &nbsp;{props.valuta}
                    </div>
                </div>
                <div role="row" className="c-table__data-row">
                    <div role="cell" className="c-table__data-cell">
                        {contentResolver(epiContext, 'detaljerReiseStipend')}
                    </div>
                    <div role="cell" className="c-table__data-cell">
                        {UtregningUtland.formatNumber(
                            UtregningUtland.regnUtReiseStotte(props.valg, props.satser).stipendKroner,
                            props.locale,
                        )}
                        &nbsp;{props.valuta}
                    </div>
                </div>
            </div>
        </div>
    );
};
interface MapStateToProps {
    epiContext: EpiContext<VeilederUtvekslingDto>;
}

export default connect(
    (state: VeilederUtvekslingAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(UtbetalingDetaljerComponent);
